import { useContext, useMemo } from "react";
import { AppContext } from "../../../context/AppContext";
import useContacts from "../../../hooks/useContacts";
import { ConvContext, DEFAULT_CONTACT_ID } from "../../../pages/ConversationContext";
import { useListViewStore } from "../../../pages/listViewStore";
import HSelect from "../../custom/input/select/Select";

export default function ConversationStatusSelector({ contactId, disabled = false }) {
  const { conversationContext, setConversationContext } = useContext(ConvContext);
  const [appProperties] = useContext(AppContext);

  const conversationStatus = conversationContext?.[contactId]?.conversationStatus || appProperties?.enums?.conversationStatus?.OPEN?.code;

  const { setData: setNumbersList } = useListViewStore();

  const { handleUpdateConversationStatus, loadingStates } = useContacts(appProperties);

  const handleConversationStatusChange = async (value) => {
    if (loadingStates[contactId]?.changeStatus || value === conversationStatus) return;
    handleUpdateConversationStatus(contactId, value, setNumbersList, setConversationContext);
  };

  const conversationStatusOptions = useMemo(
    () =>
      Object.values(appProperties?.enums?.conversationStatus)
        ?.sort((a, b) => a.order - b.order)
        ?.map((item) => ({
          label: (
            <div className="d-flex align-items-center gap-2 me-2">
              <div className={`actionIconsSprite2 ${item.code.toLowerCase()}-conversation-icon`} />
              {item.idleLabel}
            </div>
          ),
          value: item.code,
          activeLabel: (
            <div className="d-flex align-items-center gap-2 me-2">
              <div className={`actionIconsSprite2 ${item.code.toLowerCase()}-conversation-icon hs-cursor-inherit`} />
              {item.activeLabel}
            </div>
          ),
        })),
    [appProperties?.enums?.conversationStatus]
  );

    return (
    <HSelect
      labelInValue
      loading={loadingStates[contactId]?.changeStatus}
      disabled={disabled || !contactId || contactId === DEFAULT_CONTACT_ID}
      enableSearch={false}
      defaultValue={appProperties?.enums?.conversationStatus?.OPEN?.code}
      popupMatchSelectWidth={false}
      customProps={{
        value: {
          label: conversationStatusOptions?.find((item) => item.value === conversationStatus)?.activeLabel,
          value: conversationStatus,
        },
        suffixIcon: <div className="actionIconsSprite smallSize-fromNumberDropDownIcon" />,
        onSelect: (value) => handleConversationStatusChange(value),
        className: "hs-h-35-px",
      }}
      size="medium"
      options={conversationStatusOptions}
    />
  );
}
